// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dashboard-tile[data-v-fae5bece] {\n  min-width: 450px;\n  min-height: 450px;\n  background: white;\n  border: 1px solid lightgray;\n  border-radius: 15px;\n}", ""]);
// Exports
module.exports = exports;
